module.exports = __webpack_public_path__ + "img/null_space-04.73343e86.svg";